import React, { useState } from 'react'
import styles from './Button.module.scss'

interface Props {
  className?: string;
  onClick?: (e?: React.MouseEvent<HTMLElement, MouseEvent>) => void;
  style?: React.CSSProperties;
  children?: React.ReactNode;
  type?: 'submit' | 'cancel' | 'add' | 'tab';
  size?: 'small' | 'normal' | 'mini' | 'medium';
  disabled?: boolean;
  selected?: boolean;
}

const Button = (props: Props, ref) => {
  const { children, className, type, onClick, style, size = 'normal', disabled, selected } = props
  const [hooverEffect, setHooverEffect] = useState(false)

  const getClasses = (): string => {
    const classesArr = [styles.basic]
    hooverEffect && classesArr.push(styles.basicHover)

    switch (type) {
      case ('submit'):
        classesArr.push(styles.submit)
        break
      case ('cancel'):
        classesArr.push(styles.cancel)
        hooverEffect && classesArr.push(styles.cancelHover)
        break
      case ('add'):
        classesArr.push(styles.addButton)
        break
      case ('tab'):
        classesArr.push(styles.tabButton)
        break
      default: break
    }

    classesArr.push(styles[size])
    className && classesArr.push(className)
    selected && classesArr.push(styles.selected)
    disabled && classesArr.push(styles.disabled)

    return classesArr.join(' ')
  }

  const getButtonType = () => {
    if (type === 'submit') return type
    return 'button'
  }

  const handleOnClick = (e: React.MouseEvent<HTMLElement>): void => {
    e.preventDefault()
    !disabled && onClick && onClick(e)
  }

  return (
    <button
      ref={ref}
      type={getButtonType()}
      className={getClasses()}
      onClick={handleOnClick}
      style={style}
      onMouseEnter={() => setHooverEffect(true)}
      onMouseLeave={() => setHooverEffect(false)}
      onFocus={() => setHooverEffect(true)}
      onBlur={() => setHooverEffect(false)}
    >
      {children}
    </button>
  )
}

export default React.forwardRef(Button)
